import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppNavbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Verify from "./pages/Verify";
import Registry from "./pages/Registry";
import Purchase from "./pages/Purchase";

function App() {
  return (
    <Router>
      <AppNavbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify/:token" element={<Verify />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
        />
        <Route path="/registry" element={
          <ProtectedRoute>
            <Registry />
          </ProtectedRoute>
        }
        />
        <Route path="/purchase" element={
          <ProtectedRoute>
            <Purchase />
          </ProtectedRoute>
        }
        />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
